function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import { fetchCodeTypesThunk } from 'invision-core/src/components/metadata/codes/codes.actions';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { MetadataCodeLoadedSelector, MetadataCodeTypeSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import CustomerCareKeys from '../../../locales/keys';
import { retrieveContract } from '../../../reducers/actions/contract.details.actions';
import { ContractPricingPlanTableDataSelector, IsFetchingSelectedContractSelector, SelectedContractPricingPlanEtfInstanceSelector, SelectedContractPricingPlanEtfScheduleSelector } from '../../../reducers/selectors/contract.selectors';
import { SelectedContractDefinitionSelector } from '../../../reducers/selectors/offering.order.selectors';
import { EARLY_TERMINATION_FEE_CHARGE_TYPES } from '../constants/etf.charge.type.contants';
export var ContractTermsConditionsDialogController = /*#__PURE__*/function () {
  function ContractTermsConditionsDialogController($ngRedux, $timeout, $scope) {
    _classCallCheck(this, ContractTermsConditionsDialogController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      $scope: $scope,
      customerCareKeys: CustomerCareKeys,
      coreLocaleKeys: CoreLocaleKeys
    });
  }
  return _createClass(ContractTermsConditionsDialogController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.etfChargeType = EARLY_TERMINATION_FEE_CHARGE_TYPES;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          etfChargeTypes: MetadataCodeTypeSelector(CODES.EarlyTerminationFeeChargeType, store),
          isEtfChargeTypesLoaded: MetadataCodeLoadedSelector(CODES.EarlyTerminationFeeChargeType, store),
          isFetchingContract: IsFetchingSelectedContractSelector(store),
          selectedContractDetails: SelectedContractDefinitionSelector(store),
          selectedPricingPlanEtfInstance: SelectedContractPricingPlanEtfInstanceSelector(store),
          selectedPricingPlanEtfSchedule: SelectedContractPricingPlanEtfScheduleSelector(store),
          tableData: ContractPricingPlanTableDataSelector(store)
        };
      };
      var controllerActions = {
        fetchCodeTypesThunk: fetchCodeTypesThunk,
        retrieveContract: retrieveContract
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      if (!this.state.isEtfChargeTypesLoaded) {
        this.actions.fetchCodeTypesThunk(CODES.EarlyTerminationFeeChargeType);
      }
      this.actions.retrieveContract(this.selectedContractId);
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  bindings: {
    dialogTitle: '<',
    onClose: '&',
    selectedContractId: '<'
  },
  controller: ContractTermsConditionsDialogController,
  template: require('./contract.terms.conditions.dialog.template.html')
};